import React from "react";
import { Typography, Box, Stack, Card, CardContent } from "@mui/joy";
import Avatar from "@mui/material/Avatar";
import info from "../../content/info.json";

export default function InfoCard() {
  return (
    <Card
      variant="outlined"
      sx={{ borderRadius: "24px", maxWidth: 500, mx: 2, p: 4, boxShadow: "0 4px 8px rgba(0,0,0,0.2)", }}
    >
      <CardContent>
        <Stack
          direction={{ xs: "column", sm: "column", md: "row" }}
          spacing={2}
          alignItems="center"
        >
          <Avatar
            src={info.avatar}
            alt="Rafa Gould"
            sx={{ width: 150, height: 150 }}
          />
          <Box sx={{ flex: 2, textAlign: "center" }}>
            <Typography level="h2" sx={{ mb: 1 }}>
              {info.name}
            </Typography>
            <Typography level="body2">
              {info.position} at {info.organization}
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
